import React from 'react';
import { Button } from './Button';
import { CheckCircleIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://www.lunaycalma.com/cart/46841754419354:1';
export function SalesLetter() {
  const bullets = ['Técnicas probadas para calmar la ansiedad nocturna', 'Rituales que elevan tu autoestima y poder femenino', 'Hacks financieros que funcionan en la vida real', 'Afirmaciones poderosas para tu transformación', 'Guías paso a paso fáciles de seguir', 'Acceso inmediato en formato PDF', 'Lee en cualquier dispositivo', '2 bonos digitales completamente GRATIS'];
  return <section className="w-full py-20 bg-navy-900 text-white" data-id="element-233">
      <div className="max-w-4xl mx-auto px-6" data-id="element-234">
        <div className="space-y-8" data-id="element-235">
          {/* Big Promise */}
          <div className="text-center space-y-4" data-id="element-236">
            <h2 className="font-serif text-4xl lg:text-5xl leading-tight" data-id="element-237">
              🔥 La Transformación Que Has Estado Esperando
            </h2>
            <p className="text-xl text-gray-300" data-id="element-238">
              Imagina despertar cada mañana sintiéndote descansada, poderosa y
              en control de tu vida...
            </p>
          </div>

          {/* Storytelling */}
          <div className="space-y-6 text-lg leading-relaxed text-gray-200" data-id="element-239">
            <p data-id="element-240">
              <strong className="text-pink-400" data-id="element-241">Déjame adivinar...</strong> Te
              acuestas cansada pero tu mente no para. Das vueltas en la cama
              pensando en todo lo que tienes que hacer mañana. Te levantas
              agotada.
            </p>

            <p data-id="element-242">
              Miras el espejo y no reconoces a la mujer que ves. ¿Dónde quedó
              esa chica segura de sí misma? ¿Esa bichota que no le tenía miedo a
              nada?
            </p>

            <p data-id="element-243">
              Y el dinero... ay, el dinero. Llega la quincena y ya sabes que no
              va a alcanzar. Vives estresada, contando cada peso, sintiéndote
              atrapada.
            </p>

            <p className="text-xl font-bold text-gold-400" data-id="element-244">
              Pero no tiene que ser así.
            </p>

            <p data-id="element-245">
              <strong className="text-pink-400" data-id="element-246">La verdad es esta:</strong> No
              necesitas años de terapia, miles de dólares en cursos, o un
              milagro divino.
            </p>

            <p data-id="element-247">
              Necesitas las herramientas correctas. Las estrategias que
              funcionan. Y alguien que entienda tu realidad como mujer latina.
            </p>
          </div>

          {/* The Solution */}
          <div className="bg-gradient-to-r from-magenta-900/50 to-pink-900/50 rounded-3xl p-8 space-y-6" data-id="element-248">
            <h3 className="font-serif text-3xl text-center" data-id="element-249">
              Por Eso Creé "30 Noches para Dormir en Paz"
            </h3>

            <p className="text-lg text-gray-200" data-id="element-250">
              Un método completo que ataca los tres pilares de tu bienestar:
              <span className="text-pink-400 font-bold" data-id="element-251">
                {' '}
                tu mente, tu poder femenino, y tus finanzas.
              </span>
            </p>

            <div className="space-y-4" data-id="element-252">
              <div className="flex items-start gap-4" data-id="element-253">
                <span className="text-3xl" data-id="element-254">😴</span>
                <div data-id="element-255">
                  <h4 className="font-bold text-xl mb-2" data-id="element-256">
                    30 Noches para Dormir en Paz
                  </h4>
                  <p className="text-gray-300" data-id="element-257">
                    Un método emocionalmente inteligente para calmar tu mente,
                    sanar la ansiedad, y dormir profundamente cada noche.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-258">
                <span className="text-3xl" data-id="element-259">🎁</span>
                <div data-id="element-260">
                  <h4 className="font-bold text-xl mb-2" data-id="element-261">
                    Bono 1: Glow Up Bichota
                  </h4>
                  <p className="text-gray-300" data-id="element-262">
                    La guía definitiva para recuperar tu poder femenino, elevar
                    tu autoestima, y brillar con confianza auténtica.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-263">
                <span className="text-3xl" data-id="element-264">🎁</span>
                <div data-id="element-265">
                  <h4 className="font-bold text-xl mb-2" data-id="element-266">
                    Bono 2: Sobrevive a la Quincena
                  </h4>
                  <p className="text-gray-300" data-id="element-267">
                    50 hacks reales y probados para ahorrar dinero sin
                    sacrificar tu vida. Estrategias que funcionan en la economía
                    latina.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Future Vision */}
          <div className="space-y-6 text-lg text-gray-200" data-id="element-268">
            <p className="text-xl font-bold text-gold-400" data-id="element-269">
              Imagina tu vida en 30 días...
            </p>

            <p data-id="element-270">
              Te acuestas tranquila y duermes toda la noche. Te levantas con
              energía y propósito. Te miras al espejo y ves a una mujer
              poderosa, segura, radiante.
            </p>

            <p data-id="element-271">
              Tus finanzas están bajo control. Tienes un plan. Sabes exactamente
              a dónde va cada peso. Y por primera vez en mucho tiempo,{' '}
              <strong className="text-pink-400" data-id="element-272">respiras tranquila.</strong>
            </p>

            <p className="text-2xl font-bold text-center text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-gold-400" data-id="element-273">
              Esa es la mujer que vas a ser.
            </p>
          </div>

          {/* Bullets */}
          <div className="bg-white/10 rounded-3xl p-8" data-id="element-274">
            <h3 className="font-serif text-2xl mb-6 text-center" data-id="element-275">
              Con esta oferta vas a recibir:
            </h3>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-276">
              {bullets.map((bullet, index) => <div key={index} className="flex items-start gap-3" data-id="element-277">
                  <CheckCircleIcon className="w-6 h-6 text-gold-400 flex-shrink-0 mt-1" data-id="element-278" />
                  <span className="text-gray-200" data-id="element-279">{bullet}</span>
                </div>)}
            </div>
          </div>

          {/* Urgency */}
          <div className="text-center space-y-6" data-id="element-280">
            <p className="text-xl text-pink-400 font-bold" data-id="element-281">
              ⏰ Esta oferta no va a durar para siempre
            </p>
            <p className="text-gray-300" data-id="element-282">
              El precio especial de $14.97 con 2 bonos GRATIS termina pronto. No
              pierdas esta oportunidad de transformar tu vida.
            </p>
            <Button size="lg" href={CHECKOUT_URL} data-id="element-283">
              👉 Sí, quiero transformar mi vida ahora
            </Button>
          </div>
        </div>
      </div>
    </section>;
}